var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_992_11528",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.5,
    r: 12.5,
    fill: "#D83289"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_992_11528)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.5,
    r: 12.5,
    fill: "#D83289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.4394,
    cy: 6.48039,
    r: 1.58,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7195 24.7601C15.7195 28.1511 12.9705 30.9001 9.57945 30.9001C6.18842 30.9001 3.43945 28.1511 3.43945 24.7601C3.43945 21.3691 6.18842 18.6201 9.57945 18.6201C12.9705 18.6201 15.7195 21.3691 15.7195 24.7601ZM5.18531 24.7601C5.18531 27.1869 7.15264 29.1543 9.57945 29.1543C12.0063 29.1543 13.9736 27.1869 13.9736 24.7601C13.9736 22.3333 12.0063 20.366 9.57945 20.366C7.15264 20.366 5.18531 22.3333 5.18531 24.7601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1003 13.3597C19.1003 16.7508 16.3513 19.4997 12.9603 19.4997C9.56928 19.4997 6.82031 16.7508 6.82031 13.3597C6.82031 9.9687 9.56928 7.21973 12.9603 7.21973C16.3513 7.21973 19.1003 9.9687 19.1003 13.3597ZM8.56617 13.3597C8.56617 15.7865 10.5335 17.7539 12.9603 17.7539C15.3871 17.7539 17.3545 15.7865 17.3545 13.3597C17.3545 10.9329 15.3871 8.96558 12.9603 8.96558C10.5335 8.96558 8.56617 10.9329 8.56617 13.3597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95335 16.5811C9.09597 15.7749 8.56055 14.6302 8.56055 13.3604C8.56055 10.9193 10.5394 8.94043 12.9805 8.94043C14.4929 8.94043 15.8278 9.69997 16.6247 10.8584C15.8765 10.3066 14.9516 9.98043 13.9505 9.98043C11.4597 9.98043 9.44055 11.9996 9.44055 14.4904C9.44055 15.2449 9.62582 15.9561 9.95335 16.5811Z",
    fill: "#B12069"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55296 28.0607C5.69558 27.2545 5.16016 26.1098 5.16016 24.8401C5.16016 22.399 7.12906 20.3301 9.57016 20.3301C11.0825 20.3301 12.7502 21.0901 13.6402 23.1301C12.8919 22.5783 11.5512 21.4601 10.5502 21.4601C8.05935 21.4601 6.04016 23.4793 6.04016 25.9701C6.04016 26.7246 6.22543 27.4358 6.55296 28.0607Z",
    fill: "#B12069"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHh);
export default __webpack_public_path__ + "static/media/logo-hh.c2f86055cfff85e0eaf1e7196a12f8aa.svg";
export { ForwardRef as ReactComponent };